<template>
<div class="navbar">
	<div class="logo"></div>
	<ul class="main-menu">
		<li>
			<router-link to="/login">Login</router-link>
		</li>
	</ul>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.navbar {
	height: 54px;
	background: #141a21;
	z-index: 3;
	position: absolute;
	left: 0;
	right: 0;
}
.logo {
	background: url('../../assets/images/logo_light.svg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 90px;
	height: 54px;
	float: left;
	margin-left: 15px;
	user-select: none;
}
.main-menu {
	float: right;
	list-style: none;
	padding: 0 28px 0 15px;
	height: 54px;
	margin: 0;

	li {
		border-left: 2px solid #fff;
		padding-left: 18px;
		user-select: none;
		line-height: 22px;
		margin-top: 16px;
		outline: none;
		cursor: pointer;

		a {
			color: #fff;
			text-transform: uppercase;
			text-decoration: none;
			font-size: 13px;

			&:hover {
				color: #e7e7e7;
			}
		}
	}
}
</style>
